var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-flex"},[_c('div',{staticClass:"sidebar flex-none xs-hide sm-hide"}),_vm._v(" "),_c('div',{staticClass:"flex-auto md-pl2"},[(_vm.isDesk)?_c('div',[_c('image-list',{staticClass:"m0 smaller",attrs:{"images":_vm.deskList}})],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d303de4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = oUNd
// module chunks = 1